import React, { useContext } from 'react';
import { NotificationContext } from '../context/NotificationContext';
import { colors } from '../styles/theme';

// REVIEW: theme tokens
const borderColors = {
  error: '#e53935',
  success: '#43a047',
  info: colors.accentPurple,
};

const iconPaths = {
  error: 'M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  success: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
  info: 'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
};

const containerStyle = {
  position: 'fixed',
  top: '80px',
  right: '20px',
  zIndex: 10000,
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  pointerEvents: 'none',
};

// REVIEW: theme tokens
const getNotificationStyle = (type) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  background: '#ffffff',
  border: `1px solid ${colors.borderLight}`,
  borderLeft: `4px solid ${borderColors[type] || borderColors.info}`,
  borderRadius: '12px',
  padding: '12px 16px',
  fontFamily: 'Inter, sans-serif',
  fontSize: '14px',
  color: '#000000',
  maxWidth: '380px',
  minWidth: '280px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  animation: 'notif-slide-in 0.3s ease-out',
  pointerEvents: 'auto',
});

// REVIEW: theme tokens
const closeBtnStyle = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '2px',
  marginLeft: 'auto',
  color: colors.textMuted,
  flexShrink: 0,
};

function NotificationContainer() {
  const { notifications, removeNotification } = useContext(NotificationContext);

  if (notifications.length === 0) return null;

  return (
    <>
      <style>{`
        @keyframes notif-slide-in {
          from { opacity: 0; transform: translateX(80px); }
          to { opacity: 1; transform: translateX(0); }
        }
      `}</style>
      <div style={containerStyle}>
        {notifications.map((notif) => (
          <div key={notif.id} style={getNotificationStyle(notif.type)}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke={borderColors[notif.type] || borderColors.info}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ flexShrink: 0 }}
            >
              <path d={iconPaths[notif.type] || iconPaths.info} />
            </svg>
            <span style={{ flex: 1 }}>{notif.message}</span>
            <button
              style={closeBtnStyle}
              onClick={() => removeNotification(notif.id)}
              aria-label="Dismiss notification"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        ))}
      </div>
    </>
  );
}

export default NotificationContainer;
